export default "__VITE_ASSET__YJtfE89w__"